import axios from 'axios';

const fetchBlogDetails = async (id) => {
  try {
    const response = await axios.get(`https://admin.sixdindia.com/blog_details_api.php?slug=${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching blog details:', error);
    throw error;
  }
};

export default fetchBlogDetails;